import { Box, Typography } from "@mui/material";
import React from "react";

const defaultStyles = {
	flexGrow: 1,
	p: 3,
	m: 3,
	mt: 8,
	ml: 0,
	mr: 0,
	backgroundColor: "#fff",
	overflow: "auto",
	borderRadius: 2,
};

const Users = () => {
	return (
		<Box>
			<Box component="main" sx={defaultStyles}>
				<Typography>Users</Typography>
			</Box>
		</Box>
	);
};

export default Users;
